"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pragma = require("../../../../../pragma");

var _react = _interopRequireDefault(require("react"));

var css = _interopRequireWildcard(require("./VideoInfo.style"));

var _ = require("../../../..");

var _helpers = require("./helpers");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const VideoInfo = ({
  name,
  isMuted,
  duration,
  onMute,
  onUnmute,
  ...otherProps
}) => {
  const {
    minutes,
    seconds
  } = (0, _helpers.getDetailedTimingFromMs)(duration);
  const readableDuration = "".concat(minutes, ":").concat(seconds, " min");
  return (0, _pragma.createFelaElement)(_.View, _extends({
    css: css.videoInfo,
    alignItems: "center",
    justifyContent: "space-between",
    padding: ['xsmall', 'medium']
  }, otherProps), (0, _pragma.createFelaElement)(_.View, {
    flexDirection: "column"
  }, (0, _pragma.createFelaElement)(_.Text, {
    css: css.videoName
  }, name), (0, _pragma.createFelaElement)(_.Text, {
    size: "xs",
    css: css.duration
  }, readableDuration)), isMuted ? (0, _pragma.createFelaElement)(_.MutedIcon, {
    css: css.soundIcon,
    size: "large",
    onClick: onUnmute
  }) : // Todo: replace PlayIcon on icon from designer
  (0, _pragma.createFelaElement)(_.PlayIcon, {
    css: css.soundIcon,
    size: "large",
    onClick: onMute
  }));
};

var _default = VideoInfo;
exports.default = _default;
//# sourceMappingURL=VideoInfo.js.map